import { render, staticRenderFns } from "./DeleteClinic.vue?vue&type=template&id=48d81253"
import script from "./DeleteClinic.vue?vue&type=script&lang=js"
export * from "./DeleteClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports